import moment from "moment";
import ReactTooltip from "react-tooltip";
import React, { useState, useEffect } from "react";
import Typography from "../../../../common/Typography";
import "../../../../common/Pages/FeedBack/FeedBackDetailCard/feedbackDetailCard.scss";

const NegFbDetailCard = ({
  fbGiven,
  cardData,
  custData,
  storeName,
  currencyView,
  purchaseNumber,
}) => {
  const [state, setState] = useState({
    ratingImage: "/assets/images/feedback/emoji/emoji_3.svg",
  });

  const score = fbGiven?.score;

  useEffect(() => {
    const setCardData = () => {
      let newObj = {};
      if (score === 1) {
        if (cardData?.style === "number")
          newObj.ratingImage =
            "/assets/images/feedback/score/small/score_1.svg";
        else newObj.ratingImage = "/assets/images/feedback/emoji/emoji_1.svg";
      }
      if (score === 2) {
        if (cardData?.style === "number")
          newObj.ratingImage =
            "/assets/images/feedback/score/small/score_2.svg";
        else newObj.ratingImage = "/assets/images/feedback/emoji/emoji_2.svg";
      }
      if (score === 3) {
        if (cardData?.style === "number")
          newObj.ratingImage =
            "/assets/images/feedback/score/small/score_3.svg";
        else newObj.ratingImage = "/assets/images/feedback/emoji/emoji_3.svg";
      }
      if (score === 4) {
        if (cardData?.style === "number")
          newObj.ratingImage =
            "/assets/images/feedback/score/small/score_4.svg";
        else newObj.ratingImage = "/assets/images/feedback/emoji/emoji_4.svg";
      }
      if (score === 5) {
        if (cardData?.style === "number")
          newObj.ratingImage =
            "/assets/images/feedback/score/small/score_5.svg";
        else newObj.ratingImage = "/assets/images/feedback/emoji/emoji_5.svg";
      }
      setState(newObj);
    };

    setCardData();
  }, [cardData?.style, score]);

  const trxnDetail = [
    {
      value: fbGiven?.txn?.value ? `${currencyView}${fbGiven?.txn?.value}` : "",
      label: "Bill amount",
    },
    {
      value: fbGiven?.txn?.bill_number ? fbGiven?.txn?.bill_number : "",
      label: "Bill number",
    },
    {
      value: fbGiven?.txn?.table_number ? fbGiven?.txn?.table_number : "",
      label: "Table no.",
    },
    {
      value: storeName ? storeName : "",
      label: "Outlet name",
    },
  ];

  return (
    <div className="feedBackDetailCard feedBackDetailCard--danger">
      <div className="feedBackDetailCard-header">
        <img
          src={state.ratingImage}
          alt="rating_image"
          className="rating_image"
        />
        <div className="head-dets">
          <Typography customClass="left-side">
            {custData?.name} &nbsp;&nbsp;
            {"•"}&nbsp;&nbsp;
            {custData?.phone}
          </Typography>
          <div className="right-side">
            <PurchaseNumber
              purchaseNumber={purchaseNumber}
              customClass={"purchase"}
            />
            <div className="date">
              <Typography size="text-md" weight="medium">
                {moment(fbGiven?.updated_at).format("MMM D, YYYY h:mm A")}
              </Typography>
              <img
                data-tip
                alt="info"
                width="16px"
                className="tt-img"
                src="/assets/icons/alertSign.svg"
                data-for={`more-info-${fbGiven?.txn?.txn_id}`}
              />
              <ReactTooltip
                effect="solid"
                place="bottom"
                aria-haspopup="true"
                className="custom-tooltip"
                id={`more-info-${fbGiven?.txn?.txn_id}`}
              >
                Feedback Date:{" "}
                {moment(fbGiven?.updated_at).format("MMM D, YYYY h:mm A")}
                <br />
                Purchase Date:{" "}
                {moment(fbGiven?.txn?.created_at).format("MMM D, YYYY h:mm A")}
              </ReactTooltip>
            </div>
          </div>
        </div>
      </div>

      <div className="feedBackDetailCard-body">
        {fbGiven?.answer?.length > 0 && (
          <div className="comment">
            <img src="/assets/icons/quotes.svg" alt="quotes" />
            <p>{fbGiven?.answer}</p>
          </div>
        )}
        <div className="sub-body">
          {fbGiven?.hear_about_us?.length > 0 && (
            <div className="visited-from">
              <img src="/assets/icons/mic3.svg" alt="mic" />
              <div>
                <h3>How did you hear about us?</h3>
                <h6>{fbGiven?.hear_about_us?.[0]}</h6>
              </div>
            </div>
          )}
          {fbGiven?.category_options?.length > 0 && (
            <div className="reason">
              <h3>Reason for rating</h3>
              <div className="tags-row">
                {fbGiven?.category_options?.slice(0, 2)?.map((res, i) => (
                  <h6
                    key={i}
                    className="tag"
                    style={{
                      background: state.cardColor,
                    }}
                  >
                    {res}
                  </h6>
                ))}
                {fbGiven?.category_options?.length > 2 && (
                  <>
                    <h6
                      data-tip
                      className="tag"
                      data-for={`more-reason-${fbGiven?.txn?.txn_id}`}
                      style={{ cursor: "pointer", background: state.cardColor }}
                    >
                      + {fbGiven?.category_options?.length - 2}
                    </h6>

                    <ReactTooltip
                      effect="solid"
                      place="bottom"
                      id={`more-reason-${fbGiven?.txn?.txn_id}`}
                      aria-haspopup="true"
                      className="custom-tooltip"
                    >
                      {fbGiven?.category_options?.slice(2)?.join(", ")}
                    </ReactTooltip>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={`feedBackDetailCard-footer show-footer`}>
        <div className="trxns-details">
          <h4>Purchase Details</h4>
          <div className="trxns-detail-row">
            {trxnDetail?.map((det, i) =>
              det.value ? (
                <div className="trxns-detail-col" key={i}>
                  <h5>{det.value}</h5>
                  <h6>{det.label}</h6>
                </div>
              ) : (
                <React.Fragment key={i} />
              )
            )}
            {fbGiven?.txn?.items?.length > 0 && (
              <div className="trxns-detail-col">
                <div className="items-row">
                  {fbGiven?.txn?.items?.slice(0, 2)?.map((res, i) => (
                    <h6 className="item" key={i}>
                      {res?.name}
                    </h6>
                  ))}
                  {fbGiven?.txn?.items?.length > 2 && (
                    <>
                      <h6
                        data-tip
                        className="item"
                        style={{ cursor: "pointer" }}
                        data-for={`more-items-${fbGiven?.txn?.txn_id}`}
                      >
                        + {fbGiven?.txn?.items?.length - 2}
                      </h6>

                      <ReactTooltip
                        effect="solid"
                        place="bottom"
                        id={`more-items-${fbGiven?.txn?.txn_id}`}
                        aria-haspopup="true"
                        className="custom-tooltip"
                      >
                        {fbGiven?.txn?.items
                          ?.slice(2)
                          ?.map((item) => item?.name)
                          ?.join(", ")}
                      </ReactTooltip>
                    </>
                  )}
                </div>
                <h6>Item purchased</h6>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NegFbDetailCard;

const PurchaseNumber = ({ purchaseNumber, customClass }) => (
  <div
    className={`store-name${customClass?.length > 0 ? ` ${customClass}` : ""}`}
  >
    {purchaseNumber > 0
      ? `${purchaseNumber}${
          `${purchaseNumber}`.slice(-1) === "1"
            ? "st"
            : `${purchaseNumber}`.slice(-1) === "2"
            ? "nd"
            : `${purchaseNumber}`.slice(-1) === "3"
            ? "rd"
            : "th"
        } Purchase`
      : "Purchase pending"}
  </div>
);
